export default __webpack_public_path__ + "static/media/message-template-2.bf0dc26f.png";